import type { ElementType, ReactElement, ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';
// this is the allowed instance of the FormattedMessage import
// eslint-disable-next-line no-restricted-imports
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl';

export interface FormattedMessageProps<V extends Record<string, any> = Record<string, any>> extends Omit<
  MessageDescriptor,
  'id'
> {
  id: NonNullable<MessageDescriptor['id']>;
  values?: V;
  tagName?: ElementType<any>;
  children?(nodes: ReactNode[]): ReactElement | null;
}

export function FormattedMessage(props: FormattedMessageProps) {
  return <ReactIntlFormattedMessage {...props} />;
}
